import { render, staticRenderFns } from "./ConsultantQuiz.vue?vue&type=template&id=ba856f14&"
import script from "./ConsultantQuiz.vue?vue&type=script&lang=js&"
export * from "./ConsultantQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports